import { RECURRING_REPORT_TYPES, Report, ReportStatus } from 'dashboard/models/report';
import { ReportRun, ReportRunMatchStatus } from 'dashboard/models/report-run';
import Sticker from 'design-system/components/Sticker';
import { ApiModel } from 'lib/interfaces/api';

interface ReportStatusStickerProps {
  report: Report;
  reportRun?: ReportRun;
}

const matchStatusSticker = (report: Report, matchStatus: ReportRunMatchStatus) => {
  switch (matchStatus) {
    case ReportRunMatchStatus.Matched:
      return (
        <Sticker variant={RECURRING_REPORT_TYPES.includes(report.type) ? 'caution' : 'success'}>
          Matched
        </Sticker>
      );
    case ReportRunMatchStatus.Dismissed:
      return <Sticker variant='basic'>Dismissed</Sticker>;
    case ReportRunMatchStatus.NoMatch:
      return <Sticker variant='basic'>No Matches</Sticker>;
  }
};

const ReportStatusSticker = ({ report, reportRun }: ReportStatusStickerProps) => {
  if (report.attributes['redacted-at'] != null) {
    return <Sticker variant='basic'>Redacted</Sticker>;
  } else if (report.attributes.status === ReportStatus.Errored) {
    return <Sticker variant='basic'>Errored</Sticker>;
  } else if (
    report.attributes.status === ReportStatus.Pending ||
    report.attributes.status === ReportStatus.Submitted
  ) {
    // Coerce Submitted to Pending on the frontend.
    return <Sticker variant='basic'>Pending</Sticker>;
  } else if (report.attributes.status === ReportStatus.Restricted) {
    return <Sticker variant='basic'>Restricted</Sticker>;
  } else if (report.attributes['has-match'] == null) {
    return <Sticker variant='success'>Ready</Sticker>;
  }

  const matchStatus =
    reportRun?.attributes?.result ||
    (report.type === ApiModel.ReportCustomList && report.attributes.result);

  if (matchStatus) {
    return matchStatusSticker(report, matchStatus);
  }

  // If report run is not provided
  if (report.attributes['has-match']) {
    return (
      <Sticker variant={RECURRING_REPORT_TYPES.includes(report.type) ? 'caution' : 'success'}>
        Matched
      </Sticker>
    );
  } else {
    return <Sticker variant='basic'>No Matches</Sticker>;
  }
};

export default ReportStatusSticker;
